import { axiosAuthenticatedRawPost } from "../api";
import { uploadRemBgImage } from "../api/remBgUpload";
import { DELETE_IMAGE } from "../pages/Teams/TeamsService";

const statusTranslationKeys = {
  400: "user_photo_invalid_request",
  401: "user_photo_authentication_required",
  403: "user_photo_not_authorized",
  404: "user_photo_not_found",
  409: "user_photo_conflict",
  413: "user_photo_too_large",
  422: "user_photo_invalid_image",
  502: "user_photo_processing_failed",
  504: "user_photo_processing_timeout",
};

export const getUserPhotoErrorTranslationKey = (error) =>
  statusTranslationKeys[error?.response?.status ?? error?.statusCode] ||
  "user_photo_upload_failed";

const createGraphQlError = (graphQlError) => {
  const message = graphQlError?.message || "user_photo_remove_failed";
  const error = new Error(message);

  try {
    const parsedMessage = JSON.parse(message);
    if (Number.isInteger(parsedMessage?.statusCode)) {
      error.statusCode = parsedMessage.statusCode;
    }
  } catch (_) {
    // Plain GraphQL messages do not carry a structured HTTP-equivalent status.
  }

  return error;
};

export const getManagedPhotoFileName = (photoUrl) => {
  if (typeof photoUrl !== "string" || photoUrl.trim().length === 0) return "";

  try {
    const pathname = new URL(photoUrl, window.location.origin).pathname;
    return decodeURIComponent(pathname.split("/").filter(Boolean).pop() || "");
  } catch (_) {
    return photoUrl.split("/").pop()?.split("?")[0]?.split("#")[0] || "";
  }
};

export const uploadAuthenticatedUserPhoto = ({
  authenticatedUserId,
  file,
  rawPost = axiosAuthenticatedRawPost,
}) =>
  uploadRemBgImage({
    uploadType: "userImage",
    itemId: authenticatedUserId,
    file,
    rawPost,
  });

export const deleteAuthenticatedUserPhoto = async ({
  authenticatedUserId,
  currentPhoto,
  axiosGraphQL,
}) => {
  const fileName = getManagedPhotoFileName(currentPhoto);
  if (!fileName) throw new Error("user_photo_missing_file_name");

  const response = await axiosGraphQL({
    query: DELETE_IMAGE,
    variables: {
      deleteType: "userImage",
      itemId: authenticatedUserId,
      fileName,
    },
  });

  if (response?.data?.errors?.length) {
    throw createGraphQlError(response.data.errors[0]);
  }

  const result = response?.data?.data?.deleteImage;
  if (!result) throw new Error("user_photo_remove_failed");
  return result;
};
